export default "__VITE_ASSET__c61707dc__"